import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EFonts } from 'libs/styles/styling';
import { getDateStringFromEventDays } from 'libs/utils/date/dateUtils';
import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const PageHeader = (props: Props) => {
    const ctxEventView = useContext(CtxEventView);
    const { eventData } = ctxEventView;
    const { eventInfo } = eventData;

    return (
        <S_PageHeader className={props.className}>
            <S_PageTitle
                $color={eventInfo.styling.matchColor}
                $shadow={eventInfo.styling.pageHeaderShadow}
            >
                {eventInfo.name}
            </S_PageTitle>
            {eventData.eventInfo.startDateTime && (
                <S_DateRow>
                    <S_DateRowIcon
                        $color={eventInfo.styling.matchColor}
                        $shadow={eventInfo.styling.pageHeaderShadow}
                        icon={['far', 'calendar']}
                    />
                    <S_DateRowText
                        $color={eventInfo.styling.matchColor}
                        $shadow={eventInfo.styling.pageHeaderShadow}
                    >
                        {getDateStringFromEventDays(eventInfo.startDateTime, eventInfo.endDateTime)}
                    </S_DateRowText>
                </S_DateRow>
            )}
        </S_PageHeader>
    );
};

const S_PageHeader = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

const S_PageTitle = styled.div<{ $color: string; $shadow: string }>`
    color: ${(props) => props.$color};
    text-align: center;
    font-family: ${EFonts.Bold};
    font-size: 30px;
    line-height: 45px;
    text-shadow: ${(props) => props.$shadow ?? 'none'};
`;

const S_DateRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    justify-content: center;
    margin: 20px 0 0 0;
`;

const S_DateRowIcon = styled(FontAwesomeIcon)<{ $color: string; $shadow: string }>`
    font-size: 18px;
    width: 25px;
    text-align: left;
    margin-right: 10px;
    color: ${(props) => props.$color};
    text-shadow: ${(props) => props.$shadow ?? 'none'};
`;
const S_DateRowText = styled.div<{ $color: string; $shadow: string }>`
    color: ${(props) => props.$color};
    font-size: 13px;
    font-family: ${EFonts.InterSemiBold};
    text-shadow: ${(props) => props.$shadow ?? 'none'};
`;
